import { Button, Radio, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import SelectCashierModal from '../modals/SelectCashierModal';
import EventEmitter from '../../utils/eventEmitter';
import PinModal from '../modals/PinModal';
import { loadPosCashiers } from '../apis/posAPI';





const PosChooseCashier = () => {
  const [posCashiers, setPosCashiers] = useState({});

  
  const openCashierModal = () => {
    EventEmitter.dispatch('openselectcashier', true);
  };
  // console.log(posCashiers);
  useEffect(() => {
    let pos = localStorage.getItem('caspian_pos_session');
    
    if (pos) {
      let pos_ = JSON.parse(pos);
      loadPosCashiers(pos_.pos_id)
      .then(res => setPosCashiers(res))
      .catch(err => console.log(err))
    }
  },[])

  // console.log(posCashiers)
  return (
    <div className='h-screen'>
      <div className='flex justify-center items-center h-full'>
        <div className='bg-white p-3 mx-auto container' style={{maxWidth: '400px'}}>
          <div className='mb-3'>
            <h3 className='text-center text-xl'>LogIn to {posCashiers.name}</h3>
          </div>
          {/* <div className='w-2/5 bg-white'>
            <div className=''>
            <Radio.Group className='w-full mt-2'>
              <Space direction='vertical' className='w-full'>
                <Radio value={'delivered'} className='h-full w-full p-3 font-semibold w-full border'>Delivery</Radio>
                <Radio value={'pick_later'} className='h-full w-full p-3 font-semibold w-full border'>Pick Later</Radio>
              </Space>
            </Radio.Group>
          </div>
          </div> */}
          <div className='border rounded mb-3'>
            <Button type='text' onClick={openCashierModal} className='w-full'>Select Cashier</Button>
          </div>
          <div className='border rounded'>
            <Button danger type='primary' className='w-full'>Close Session</Button>
          </div>
        </div>
      </div>
      <SelectCashierModal cashiers={posCashiers.cashiers}/>
      <PinModal />
    </div>
  )
}

export default PosChooseCashier;